﻿
//
// the main js entry point
// this sets up anything that every page will need
// or loads in anything the current page needs
//
export class App {
	constructor() {
		
		// creating a global variable in to which the url of any 3rd party scripts that are loaded
		// this is to ensure that we do not duplicate the loading of anything
		if (typeof window.scripts === "undefined") {			
			window.scripts = [];
		}

		this.attachEvents()
		this.loadDependantModules();
	}

	///
	Ready() {
		//console.log('dom loaded and ready');
	}

	///
	attachEvents() {
		// dom content has loaded
		var _ = this;
		if (document.readyState !== 'loading') {
			_.Ready();
		} else {
			document.addEventListener('DOMContentLoaded', function () {
				_.Ready();
			});
		}
	}

	///
	async loadDependantModules() {
		await Promise.all(
			[
				// core
				//this.getDebugHelpers(),
				this.getCookieManager(),
				this.getMainNavToggle(),

				// components
				this.getB2C(),
				this.getCampaignHero(),
				this.getPreQualFormScripts(),
			]
		);
	}

	async getCookieManager()
	{
		const cookieManager = await import( './modules/cookie-manager' );
		cookieManager.CookieManagerInit();
	}

	async getDebugHelpers() {
		const mainNav = await import('./modules/debug-helpers');
		mainNav.DebugHelpers();
	}

	async getMainNavToggle() {
		const mainNav = await import('./modules/main-nav');
		mainNav.SetUpMainNavToggle();
	}

	async getB2C() {
		if (document.querySelector('#extension_SecurityQuestion') != null) {
			const bc2Script = await import('./modules/b2c');
			bc2Script.initB2C();
		}
	}

	// 
	async getCampaignHero() {
		if (document.querySelector('.campaign-hero__slides') != null) {
			const hero = await import('./modules/campaign-hero');
			hero.initCampaignHero();
		}
	}

	// Load PreQual form scripts if required
	async getPreQualFormScripts() {
		if (document.querySelector('#PrequalificationQuestionsForm') != null) {
			const formScripts = await import('./modules/pre-qual-form');
			formScripts.initPreQualFormHandlers();
		}
	}
}
